var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.254 16.982a.66.66 0 00.92 0l2.94-2.94a.65.65 0 00.145-.713.605.605 0 00-.145-.206L18.15 10.16a.639.639 0 00-.918 0 .66.66 0 000 .919l1.848 1.837h-8.335a.649.649 0 000 1.298h8.357l-1.849 1.848a.66.66 0 000 .92z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.513 20.953a.703.703 0 01-.703.702H7.865A2.865 2.865 0 015 18.79V8.52a2.865 2.865 0 012.865-2.865h5.945a.703.703 0 110 1.406H7.865a1.46 1.46 0 00-1.46 1.46v10.27c0 .805.654 1.459 1.46 1.459h5.945c.389 0 .703.314.703.703z",
    fill: "#C4C4C4"
  })));
}
export default SvgLogOut;